import React from "react";
import Logo from "./Logo";
import Description from "Portal/Description/View";
import CSSModules from "react-css-modules";
import css from "./page.scss";

const Page = ({
  instanceId,
  children,
  title,
  description,
  logoImageUrl,
  logoImageAltText,
  backgroundImageUrl,
  backgroundImageAltText,
  style: userStyles = {},
  titleStyle = {}
}) => (
  <div styleName="wrapper">
    <div
      style={{
        zIndex: 0,
        backgroundImage: backgroundImageUrl
          ? `url(${backgroundImageUrl})`
          : undefined
      }}
      styleName="header"
      aria-label={backgroundImageAltText}
    />
    <div styleName="body" style={userStyles}>
      <Logo logoImageUrl={logoImageUrl} logoImageAltText={logoImageAltText} />
      {title && title.length ? (
        <div styleName="title">
          <Description
            instanceId={instanceId}
            titleStyle={titleStyle}
            title={title}
            description={description}
          />
        </div>
      ) : null}
      {children}
    </div>
  </div>
);

export default CSSModules(css)(Page);
